












import { Component, Vue } from "vue-property-decorator";
import GraphicClient from "@/resources/mixins/graphicClient/graphicClient";
import { mixins } from "vue-class-component";
import CameraOptionsComponent from "@/app/views/nubii/components/graphicClientOptions/cameraOptions.component.vue";
import SpeedNetworkingComponent from "@/app/components/modals/speedNetworking/speedNetworking.component.vue";

@Component({
  name: "main-component",
  components: { SpeedNetworkingComponent, CameraOptionsComponent },
})
export default class MainComponent extends mixins(GraphicClient) {
  constructor() {
    super();
    window["vueMessageReceiver"] = this;
  }
  get focusMode(): boolean {
    return this.$store.getters["MeetingStore/getFocusMode"];
  }
}
